<template>
  <div class="data_brain_wrap">
   <!--关于晴天-->
    <div class="brain_title">
        {{$t("homeAbout.title")}}
      <div class="sub_title">{{$t("homeAbout.subTitle")}}</div>
    </div>
    <div class="brain_desc">
      <!-- 修改：添加浮动样式 -->
      <div v-animate-on-scroll="'animate__backInRight'" class="explain_bg" style="float: right;">
        <img class="explain_img" src="@/assets/img/home/1749007657_bzMz.jpg" alt=""/>
      </div>
      <div v-animate-on-scroll="'animate__backInLeft'" class="explain">
          {{$t("homeAbout.brainDesc1")}}<br/>
          {{$t("homeAbout.brainDesc2")}}<br/>
        <div class="learn_more" v-animate-on-scroll="'animate__slideInLeft'" @click="handleNavigate('/about')">{{$t("homeAbout.learnMore")}}</div>
      </div>
    </div>
    <!--已投企业-->
    <div class="enterprise">
      <div class="enterprise_title">{{$t("homeAbout.portfolioCompanies")}}</div>
      <div class="enterprise_en">{{$t("homeAbout.portfolioCompaniesEn")}}</div>
      <div class="company_presentation">
        <img class="company_listed" src="@/assets/img/home/1745566970_mvZe.png" alt=""/>
        <div class="will" v-animate-on-scroll="'animate__fadeInUp'">
          <div class="will_title">{{$t("homeAbout.willTitle")}}</div>
          <div class="will_en">{{$t("homeAbout.willEn")}}</div>
        </div>
        <el-row class="card_wrap" type="flex" v-animate-on-scroll="'animate__fadeInUp'">
          <el-col
              class="brain_item"
              :span="6"
              :lg="7"
              :sm="11"
              :xs="11"
              v-for="(item, index) in cardList"
              :key="index"
          >
            <div class="card_img" @click.prevent.stop="handleToDemo(index + 1)">
              <img class="item_card_img" :src="item.bgImg"  alt="">
            </div>
            <div @click.prevent.stop="handleToDemo(index + 1)" class="item_title">{{ item.title }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--创始人-->
    <div class="founder">
      <div class="founder_title">{{$t("homeAbout.founderTitle")}}</div>
      <div class="founder_en">{{$t("homeAbout.founderEn")}}</div>
      <div class="founder_profile">
        <div class="avatar" style="float: left;">
          <img class="avatar_img" src="@/assets/img/home/1745896043_tTp9.png" alt=""/>
        </div>
        <div class="introduced" v-animate-on-scroll="'animate__zoomIn'">
          <h3 class="describes">
            <span class="name">{{$t("homeAbout.founderName")}}</span>
            <span class="degree">{{$t("homeAbout.founderDegree1")}} {{$t("homeAbout.founderDegree2")}}</span>
          </h3>
          <div class="describe">
            <span>{{$t("homeAbout.founderDescribe1")}}</span><br/>
            <span>{{$t("homeAbout.founderDescribe2")}}</span>
          </div>
          <div class="resume" @click="handleNavigate('/about')" v-animate-on-scroll="'animate__backInRight'">{{$t("homeAbout.learnMore")}}</div>
        </div>
      </div>
    </div>
    <!--探索更多-->
    <div class="explore_more">
      <div class="companyIntro15">
        <div class="company_dec_content" v-animate-on-scroll="'animate__slideInUp'">
          <div class="company_name">{{$t("homeAbout.companyDec1")}}</div>
          <div class="company_dec">{{$t("homeAbout.companyDec2")}}</div>
          <div class="explore_more_title" @click="handleNavigate('/seven')">
            {{$t("homeAbout.exploreMoreTitle")}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    cardList()
    {
      return [
        {
          title: this.$t("homeAbout.company1"),
          bgImg:require("@/assets/img/home/1745567661_JDNx.jpg")
        },
        {
          title: this.$t("homeAbout.company2"),
          bgImg:require("@/assets/img/home/1745567661_usaK.jpg")
        },
        {
          title: this.$t("homeAbout.company3"),
          bgImg:require("@/assets/img/home/1745567642_knlZ.jpg")
        },
        {
          title: this.$t("homeAbout.company4"),
          bgImg:require("@/assets/img/home/1745567632_njYg.jpg")
        }
      ]
    }
  },
  data() {
    return {

    }
  },
  methods:{
    handleNavigate(url){
      this.$router.push(url)
    },
    handleToDemo(index)
    {
      this.$router.push('/portfolio-companies/' + index)
    }
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  //padding: 50px 0;
  padding-top: 20px;
  background: #ffffff;
  text-align: center;
  font-family: $font-family;
  @media screen and (max-width: 768px) {
    padding:1.5rem 0;
  }
  .brain_title {
    position: relative;
    color: #203040;
    font-size: $title-font-size;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: $phone-title-font-size;
    }
  }
  .sub_title{
    color: #fccc0c;
    /*font-family: Arial;*/
    font-size: $subtitle-font-size ;
    margin-bottom:20px;
    @media screen and (max-width: 768px) {
      font-size: $phone-subtitle-font-size;
      //margin-bottom: 2rem;
    }
  }
  .brain_desc {
    width: 70%;
    margin: 0 auto;
    position: relative;
    color: rgba(32, 48, 64, 0.75);
    @media screen and (max-width: 768px) {
      width: 95%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .explain{
    width: 100%; /* 修改：宽度调整为100% */
    font-size: $content-font-size;
    color: #000000;
    line-height: 2;
    text-align: left;
    @media screen and (max-width: 768px) {
      font-size: $phone-content-font-size;
      width: 95%;
    }
  }
  .explain_bg{
    width: 40%;
    height: auto; /* 修改：高度自适应 */
    margin-left: 10px;
    @media screen and (max-width: 768px) {
      width: 95%;
      height: 90%;
      margin-left: 0;
    }
  }
  .explain_img{
    transform: translateX(10px);
    height: auto; /* 修改：高度自适应 */
    width: 100%; /* 修改：宽度调整为100% */
    border-radius: 10px;
    @media screen and (max-width: 768px) {
      transform: translateX(0px);
      margin: 20px 0;
      width: 100%;
      border-radius: 10px;
    }
  }
  .learn_more{
    margin-top: 30px;
    width: 300px;
    background: transparent;
    border-radius: 35px;
    padding: 8px 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px #794bb7 solid;
    color: #794bb7;
    font-size: 1rem;
    @media screen and (max-width: 768px) {
      margin-top: 1.5rem;
      font-size: 1rem;
      margin-bottom: 0.8rem;
      bottom: 0.7rem;
      min-width: 10rem;
      padding: 0.4rem 0.8rem;
    }
    &:hover{
      background: #794bb7;
      color: #fccc0c;
      cursor: pointer;
    }
  }
  //已投企业
  .enterprise{
    width: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    flex-direction: column;
    .enterprise_title{
      position: relative;
      color: #203040;
      font-size: $title-font-size;
      font-weight: bold;
      /*padding: 30px 0;*/
      margin-top: 30px;
      @media screen and (max-width: 768px) {
        font-size: $phone-title-font-size;
      }
    }
    .enterprise_en{
      color: #fccc0c;
      font-size: $subtitle-font-size;
      @media screen and (max-width: 768px) {
        font-size: $phone-subtitle-font-size;
      }
    }
    .company_presentation{
      position: relative;
      width: 100%;
      display: flex;
      .company_listed{
        height: 500px;
        position: absolute;
        width: 100%;
        object-fit: fill;
        top: -70px;
        @media screen and (max-width: 768px) {
          height: 20rem;
          object-fit: cover
        }
      }
      text-align: center;
      .will{
        color: #ffffff;
        position: absolute;
        top: 80px;
        width: 100%;
        text-align: center;
        //left: 30%;
        //transform: translateX(-50%);
        @media screen and (max-width: 768px) {
          top: 5rem;
        }
        .will_title{
          font-size: 2rem;
          line-height: 1.5;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          @media screen and (max-width: 768px) {
            font-size: 1.6rem;
          }
        }
        .will_en{
          display: flex;
          line-height: 1.5;
          font-size: 2.1rem;
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 3rem;
          transform: translateX(-50%);
          @media screen and (max-width: 768px) {
            font-size: 1.4rem;
            white-space: nowrap;
            top: 2.5rem;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .card_wrap {
    width: 70%;
    margin: 200px auto 0 auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-top: 11rem;
    }
    .brain_item {
      transition: background-color 1s;
      margin-right: 15px;
      @media screen and (max-width: 768px) {
        font-size: $phone-content-font-size;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 1.6rem;
      position: relative;
      .item_title {
        transition: all 0.5s;
        font-size: $content-font-size;
        color: #203040;
        text-align: center;
        padding: 12px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: $phone-content-font-size;
          text-align: center;
        }
      }
      .card_img{
        display: flex;
        width: 100%;
        max-width: 100%;
        overflow: hidden;
        border-radius: 20px 20px 0 0;
        .item_card_img{
          border-radius: 20px 20px 0 0;
          height: 100%;
          width: 100%;
          transition: transform 0.3s ease;  /* 添加过渡效果，使放大过程更平滑 */
          object-fit: contain;  /* 保证图片在容器内不会失真 */
          @media screen and (max-width: 768px) {
            border-radius: 0.6rem 0.6rem 0 0;
          }
        }
      }
      //&:hover .item_card_img{
      //  transform: scale(1.2);  /* 放大 4 倍 */
      //}
      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
      &:hover {
        cursor: pointer;
        background: #794bb7;
        .item_title{
          color: #fff;
        }
        .item_card_img{
          transform: scale(1.1);
          transition: transform 0.5s;
        }
      }
    }
  }
  //创始人
  .founder{
    position: relative;
    margin-top: 40px;
    padding:10px 0;
    width: 100%;
    background: url("../../assets/img/home/1746602841_rvJN.jpg") no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 768px) {
      background:none;
      height: 100%;
      margin-top:3rem;
    }
    .founder_title{
      position: relative;
      color: #203040;
      font-size: $title-font-size;
      font-weight: bold;
      padding: 30px 0 0 0;
      @media screen and (max-width: 768px) {
        font-size: $phone-title-font-size;
      }
    }
    .founder_en{
      color: #fccc0c;
      font-size: $subtitle-font-size;
      @media screen and (max-width: 768px) {
        font-size: $phone-subtitle-font-size;
      }
    }
    .founder_profile{
      width: 70%;
      margin: 0 auto;
      //display: flex;
      //justify-content: center;
      @media screen and (max-width: 768px) {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
      }
      .avatar{
        height: 560px;
        width: 360px;
        margin-right:100px;
        transform: translateY(-80px);
        @media screen and (max-width: 768px) {
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          width: 20rem;
          height:30rem;
          display: flex;
          justify-content: center;
          margin:0;
        }
        .avatar_img{
          height: 100%;
          width: 100%;
        }
      }
      .introduced{
        position: relative;
        margin-top: 80px;
        @media screen and (max-width: 768px) {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 0 1rem 3rem 1rem;
        }
        .describes{
          display: flex;
          align-items: center;
          color: #000000;
          .name{
            font-size: 1.6rem;
            line-height: 2;
            margin-right: 20px;
            @media screen and (max-width: 768px) {
              font-size: 1.2rem;
            }
          }
          .degree{
            font-size: 1.3rem;
            @media screen and (max-width: 768px) {
              font-size: 1rem;
            }
          }
        }

        .describe{
          text-align: left;
          span{
            font-size: $content-font-size;
            line-height: 2;
            color: #000000;
            @media screen and (max-width: 768px) {
              font-size: $phone-content-font-size;
            }
          }
        }
        .resume{
          background: transparent;
          border-radius: 35px;
          padding: 8px 36px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px #794bb7 solid;
          color: #794bb7;
          font-size: 16px;
          width: 300px;
          margin-top: 60px;
          @media screen and (max-width: 768px) {
            width: 10rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%)!important;
            font-size: 1rem;
            margin-bottom: 0.8rem;
            bottom: -1rem;
            padding: 0.4rem 0.8rem;
          }
          &:hover{
            background: #794bb7;
            color: #fccc0c;
            cursor: pointer;
          }
        }
      }

    }
  }
  .founder:after{
      content: "";
      display: block;
      clear: both;
  }
  //探索更多
  .explore_more{
    position: relative;
    width: 100%;
    .companyIntro15{
      width: 100%;
      text-align: center;
      color: #fff;
      padding: 110px 0;
      background: 50% 0 no-repeat;
      background-size: cover;
      background-attachment: fixed;
      background-image: url("../../assets/img/home/1745570686_reut.jpg");
      background-size: 100% 100%;
      @media screen and (max-width: 768px) {
        height: 15rem;
        background-attachment:scroll;
        margin-top: 2rem;
      }
      .company_dec_content{
        .company_name{
          font-weight: bold;
          font-size: 2.3rem;
          margin-bottom: 30px;
          display: block;
          @media screen and (max-width: 768px) {
            font-size: 1.5rem;
            margin-bottom:1rem;
          }
        }
        .company_dec{
          font-size: 1.3rem;
          line-height: 1.72;
          margin: 0 auto;
          max-width: 1100px;
          margin-bottom: 50px;
          @media screen and (max-width: 768px) {
            font-size: 0.8rem;
            margin-bottom: 1.5rem;
            font-weight: bold;
          }
        }
        .explore_more_title{
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          text-align: center;
          border: 1px solid #fff;
          color: #fff;
          padding: 0 46px;
          line-height: 42px;
          font-size: 0.9rem;
          @media screen and (max-width: 768px) {
            padding: 0.8rem 1rem;
            font-size: 0.9rem;
          }
          &:hover{
            border: 1px solid #794bb7;
            background: #794bb7;
            color: #fccc0c;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.home_title{

}
</style>
